import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f460b74e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["selected"]
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "leading-[20px] text-Text/text_low" }
const _hoisted_5 = { class: "leading-[20px] whitespace-nowrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-calendar-alt text-Text/text_medium text-[20px]" }, null, -1))
const _hoisted_7 = { class: "date-picker--q-date" }

import { computed, ref } from 'vue';
import { IncrediMenu } from 'incredi-ui';
import type { QDateProps } from 'quasar';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-picker-input',
  props: {
    qDateOptions: null,
    navigationMinYearMonth: null,
    navigationMaxYearMonth: null,
    modelValue: null,
    label: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({ (e: 'update:modelValue', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  qDateOptions: QDateProps['options'];
  navigationMinYearMonth: QDateProps['navigationMinYearMonth'];
  navigationMaxYearMonth: QDateProps['navigationMaxYearMonth'];
  modelValue: string;
  label: string;
}




const datePickerMenuOpen = ref(false);

const openMenu = () => {
  datePickerMenuOpen.value = true;
};
const closeMenu = () => {
  datePickerMenuOpen.value = false;
};

const changeDate = (value: string) => {
  if (value) emit('update:modelValue', value);
  closeMenu();
};

const formattedDate = computed(() => moment(props.modelValue, 'YYYY/MM/DD').format('D MMM YYYY'));

expose({
  openMenu,
  closeMenu,
});

return (_ctx: any,_cache: any) => {
  const _component_q_date = _resolveComponent("q-date")!

  return (_openBlock(), _createBlock(_unref(IncrediMenu), {
    modelValue: datePickerMenuOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datePickerMenuOpen).value = $event)),
    direction: "bottom-sticky-left",
    "offset-y": 5,
    "offset-x": 0
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_date, {
          options: __props.qDateOptions,
          "model-value": __props.modelValue,
          minimal: "",
          "navigation-min-year-month": __props.navigationMinYearMonth,
          "navigation-max-year-month": __props.navigationMaxYearMonth,
          "onUpdate:modelValue": changeDate
        }, null, 8, ["options", "model-value", "navigation-min-year-month", "navigation-max-year-month"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "date-picker--q-date--input w-[160px] flex-nowrap flex items-center gap-[19px]",
          selected: datePickerMenuOpen.value
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formattedDate)), 1)
          ]),
          _hoisted_6
        ], 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})